
    import styled from 'styled-components';
    import * as Copy from 'styles/components/copy';

    export const Content = styled.div`
        display: flex;
        position: relative;
        font-family: CNN Condensed;

        flex-direction: column;
        justify-content: center;
        align-items: center;

        width: 100%;
        margin: 0 auto;

        flex: 1 0 auto;
    `;

    export const Title = styled(Copy.ParagraphElement)`
        display: flex;
        font-weight: 200;
        font-size: 25px;
        text-align: center;
        letter-spacing: 1.15px;
        max-width: 700px;
        
        margin: 0 0 30px;
        padding: 0;

        ${({theme}) => theme.breakpoints['md']}
        {
            font-size: 35px;
            letter-spacing: 2.52px;
        }
    `;

    export const Subhed = styled(Copy.ParagraphElement)`
        max-width: 700px;
        font-size: 27px;
        font-weight: 200;
        letter-spacing: 1.46px;
        text-align: center;
        
        margin: 0 0;
        padding: 0;
    `;

    export const OptionContainer = styled.div`
        display: flex;
        position: relative;
        flex-direction: column;
        margin: 25px 0 10px;
        width: 100%;
        
        align-items: center;

        .cloud &
        {
            flex-direction: row;
            flex-wrap: wrap;
            justify-content: center;

            max-width: 550px;
        }

        .smooth-dnd-draggable-wrapper
        {
            overflow: unset !important;
            display: flex !important;
            justify-content: center;
            
            transform: scale(1);

            &.smooth-dnd-ghost
            {
                transform: scale(1.2);
            }
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            margin: 40px 0 20px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            margin: 50px 0 30px;
        }
    `;

    export const OptionLabel = styled(Copy.ParagraphElement)`
        pointer-events: none;
        font-family: CNN Condensed;
        font-size: 18px;
        font-weight: 200;
        letter-spacing: 1.3px;
        white-space: nowrap;
        
        margin: 0;
        padding: 0;

        .uppercase &
        {
            text-transform: uppercase;
        }

        .lowercase &
        {
            text-transform: lowercase;
        }

        .cloud &
        {
            font-size: 18px;
        }

        .md_label &
        {
            font-size: 21px;
        }

        .sm_label &
        {
            font-size: 16px;
        }
    `;

    export const Option = styled.div`
        display: flex;
        pointer-events: none;
        position: relative;
        user-select: none;
        cursor: pointer;

        border-radius: 30px;
        background: #f1d642;
        color: ${({theme}) => theme.white};
        
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 5px 18px;
        
        width: min-content;

        margin-bottom: 10px;

        animation: draggable 1000ms ease-in-out ${({idx}) => (500 + (idx * 250)) }ms 1 normal forwards running;

        .init &
        {
            animation: unset;
        }

        transition: background 500ms, color 500ms;

        @keyframes draggable
        {
            0%
            {
                transform: translate(0%, 0%);
            }

            33%
            {
                transform: translate(0%, 25%);
            }

            66%
            {
                transform: translate(0%, -10%);
            }

            100%
            {
                transform: translate(0%, 0%);
            }
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            padding: 8px 18px;
            margin-bottom: 15px;
            min-height: 45px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            padding: 8px 18px;
            margin-bottom: 20px;
            min-height: unset;
        }
    `;

    export const Instruction = styled(Copy.SpanElement)`
        font-size: 16px;
        font-weight: 500;
        letter-spacing: 0.35px;
    `;


    export const Submit = styled(Copy.SpanElement)`
        user-select: none;
        pointer-events: none;

        display: flex;
        position: relative;
        border-radius: 20px;
        border: solid 0.5px #979797;
        background-color: #ddf4f6;

        font-size: 16px;
        font-weight: 500;
        color: ${({theme}) => theme.gray7};

        text-transform: lowercase;

        flex-direction: row;
        justify-content: center;
        align-items: center;

        width: 128px;
        height: 31px;

        margin-top: 30px;

        opacity: 0.75;

        transition: color 500ms, opacity 500ms;

        &.enabled
        {
            pointer-events: auto;
            cursor: pointer;
            color: #437079;
            opacity: 1;
        }

        ${({theme}) => theme.breakpoints['sm']}
        {
            margin-top: 40px;
        }

        ${({theme}) => theme.breakpoints['md']}
        {
            margin-top: 50px;
        }
    `;